<template>
  <div>
    <!-- map -->
    <div class="contentWrap">
      <p style="height:50px;line-height:50px;display: inline-block;margin-right: 10px;">Map</p>
      <!-- 地图------start value1为true时，显示高德-->
      <!-- <el-switch v-model="value1" inactive-text="谷歌地图" active-text="高德地图" /> -->
      <div style="min-height:100px;width: 100%">
        <!-- 高德地图 和 谷歌地图-->
        <el-container style="padding-left: 1px;padding-right: 1px;position: relative;background:white;border-radius: 10px;" class="right"><!--0925 cici-->
          <keep-alive>
            <deviceListMapTem ref="maps" :is-show-g-d-map="value1" :have-location-info="haveLocationInfo" :height="height" @fullScreen="fullScreen" />
          </keep-alive>
        </el-container>
      </div>
      <!-- 地图------end -->
    </div>
    <!-- machines -->
    <div class="contentWrap">
      <p style="height:50px;line-height:50px;">MACHINES</p>
      <div style="min-height:100px;">
        <!-- 删选 -->
        <!-- <div class="filter-container">
          <div style="display: inline-block;margin-bottom: 10px;vertical-align: top;">
            <el-date-picker v-model="value7" type="daterange" :range-separator="$t('basicinfo.to')" :start-placeholder="$t('basicinfo.startDate')" :end-placeholder="$t('basicinfo.endDate')" @change="changeSearch" />
          </div>
          <el-select v-model=" listQuery.customer" :placeholder="$t('basicinfo.customerName')" class="filter-item" filterable clearable style="width: 20%; padding-left: 10px;padding-right: 10px" @change="changeSearch(stQuery.customer,'customer')">
            <el-option v-for="item in customerOptions" :key="item.id" :label="item.companyName" :value="item.id" />
          </el-select>
          <el-select v-model="listQuery.stateAction" :placeholder="$t('basicinfo.statusAction')" class="filter-item" filterable clearable style="width: 20%; padding-left: 10px;padding-right: 10px" @change="changeSearch(listQuery.stateAction,'stateAction')">
            <el-option v-for="item in stateActionOptions" :key="item.id" :label="item.stateAction" :value="item.id" />
          </el-select>
          <button class="el-icon-search greenBtn" @click="search">{{ $t("basicinfo.search") }}</button>
          <button class="el-icon-refresh greenBtn" @click="restore">{{ $t("basicinfo.restore") }}</button>
        </div> -->
        <el-table :data="datalist" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}" border>
          <el-table-column prop="updateTime" label="Ddate time" sortable />
          <!-- <el-table-column prop="MechId" :label="$t('basicinfo.customerName')" /> -->
          <el-table-column prop="deviceName" label="Machine name" />
          <el-table-column prop="deviceSn" label="Machine number" />
          <!-- <el-table-column prop="deviceStatus" :label="$t('basicinfo.statusAction')" width="180" /> -->
          <!-- <el-table-column prop="" label="" /> -->
          <el-table-column prop="action" label="Action" width="180">
            <template slot-scope="scope">
              <div style="text-align: center;">
                <!-- <button class="greenBtn" @click="goView(scope.row)">{{ $t("basicinfo.view") }}</button> -->
                <el-button type="primary" size="mini" @click="goView(scope.row)">View</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 列表模块————分页 -->
        <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
          <div class="pagination-container">
            <el-pagination
              v-if="pageshow"
              background
              current-page.sync="listQuery.pageInfo.page"
              :page-sizes="listQuery.pageInfo.pageList"
              :page-size="listQuery.pageInfo.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="listQuery.pageInfo.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findDeviceList } from '@/api/trionic'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime.js'
import deviceListMapTem from '@/components/deviceListMapTem'// 高德和谷歌地图
export default {
  components: {
    deviceListMapTem // 地图
  },
  data() {
    return {
      // 地图----start
      height: '400px',
      value1: false,
      locationList: [],
      isShowMapFloat: true, // 是否显示图示
      haveLocationInfo: true, // 是否有定位信息
      // 地图----end
      listQuery: { // 分页
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      total: 0, // 分页
      datalist: [], // 列表数据
      customerOptions: [], // 下拉框--客户
      stateActionOptions: [], // 下拉框--状态
      value7: null, // 起始日期,
      map: null
    }
  },
  created() {
    this.queryList()
  },
  mounted() {
    this.$nextTick(() => {
    })
    if (this.$store.state.map == 'gdMap') { this.value1 = true } else { this.value1 = false }
    // var _this = this
    // this.GDMap = new AMap.Map('map-container', {
    //   resizeEnable: true, // 是否监控地图容器尺寸变化
    //   mapStyle: 'amap://styles/whitesmoke'
    // })

    // this.GDMap.plugin(['AMap.ToolBar'], function() {
    //   _this.GDMap.addControl(new AMap.ToolBar())
    // })
  },
  methods: {
    // 获取地址信息--地图
    getPosition({ address, lat, lng, name }) {
      this.postForm.detailedAddress = address
      this.postForm.longitude = String(lng)
      this.postForm.latitude = String(lat)
    },
    fullScreen(height) {
      this.height = height
    },
    // 查询
    queryList() {
      console.log('this.$store', this.$store)
      var param = {
        // 'companyId': this.$store.state.company ? this.$store.state.company.id : '',
        companyIdList: [48],
        deviceTypeList: [],
        displayTime: new Date(getDateAndHour(new Date().getTime(), 'noTime')).getTime() - 8 * 60 * 60 * 1000, // 当天零点的时间戳
        // endDate: 1570914000000,
        pageNum: this.listQuery.pageInfo.pageNum,
        pageSize: this.listQuery.pageInfo.pageSize,
        myToken: this.$store.state.token
        // startDate: ''
      }
      // if (this.$store.state.company)param.companyIdList.push(this.$store.state.company.id)
      findDeviceList(param).then(response => { //  api:list
        this.customerOptions = response.resultModel.list
        this.datalist = response.resultModel.list
        this.total = response.resultModel.total
        this.listQuery.pageInfo.total = response.resultModel.total
        this.locationList = []
        var num = 0
        this.datalist.forEach((v) => {
          // if (v.mcuId == '05d7ff393430475043166037' || v.mcuId == '05d7ff373637574e43136338') {
          //   v.deviceType = 2
          // }
          if (v.lat && v.lon)num++
          if (v.createTime)v.updateTime = getDateAndHour(v.createTime)
          this.locationList.push({
            deviceName: v.deviceName,
            mcuId: v.mcuId,
            lType: v.lType,
            lat: v.lat,
            lon: v.lon,
            updataTime: v.createTime
          })
        })
        // if (num == 0) { this.haveLocationInfo = false } else { this.haveLocationInfo = true }
        // console.log(this.locationList)
        this.$refs.maps.setMakers(this.locationList)
      })
      // this.listLoading = true
      // this.markers = []
      // this.googleMarkers = []
      // this.GDMap = new AMap.Map('map-container', {
      //   resizeEnable: true, // 是否监控地图容器尺寸变化
      //   mapStyle: 'amap://styles/whitesmoke'
      // })
      // getAllDevices2(this.listQuery).then(response => { // api:allDevices
      //   this.datalist = response.resultModel.list
      //   this.listQuery.pageInfo.total = response.resultModel.total
      //   this.listLoading = false
      // })
    },
    // 筛选改变事件
    changeSearch(val, attr) {
      this.listQuery.page = 1
      this.queryList()
    },
    // 筛选
    search(val) {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 重置
    restore(val) {
      // this.fetchData()
    },
    // 分页----start
    handleSizeChange(val, e) {
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      console.log(val)
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    // 分页----end
    // 查看详情
    goView(row) {
      // debugger
      const routeData = this.$router.resolve({
        path: '/allDevices/trionicDetail',
        query: {
          mcuId: row.mcuId
          // mcuId: '05d9ff333432554e43133650'
        }
      })
      window.open(routeData.href, '_self')
      // this.$router.push({ path: '/trionicDetail', query: { mcuId: '05d9ff333432554e43133650' }}) // 暂用--无需校验账号密码--trionic
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0;
  padding:0;
}

</style>
<style rel="stylesheet/scss" lang="scss" scoped>
  #map-container {
    width:100%;
    height:700px;
  }
  #gmap-container {
    width:100%;
    height:700px;
  }
  .myTableBtn{
    height: 28px;
    line-height: 28px;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 12px;
  }
</style>
